export enum CellType {
  EMPTY = 0,
  TOWER = 1,
  WALL = 2,
  GATE = 3,
  PATH_ENTRY = 4,
  PATH_EXIT = 5,
  OBSTACLE = 6,
  DORMANT_SPAWN = 7,
  BLOCKER = 8,
  HIDDEN_SPAWN = 9,
  /** Cell is on the wave's promised path during the pre-wave countdown.
   *  Visually traversable but locked against tower placement so the river
   *  animation's path matches what the wave will actually use. */
  PATH_RESERVED = 10,
}

export interface Cell {
  type: CellType;
  x: number;
  y: number;
  blocksPath: boolean;
  blocksSynergy: boolean;
  hp?: number;
  occupant?: EntityRef | null;
}

export interface EntityRef {
  id: string;
  kind: "tower" | "wall";
}

export interface PlaceResult {
  valid: boolean;
  reason?:
    | "OCCUPIED"
    | "BLOCKS_PATH"
    | "OUT_OF_BOUNDS"
    | "PROTECTED"
    | "PATH_LOCKED";
}

export type QualityLevel = "high" | "medium" | "low" | "off";

export interface SerializedGrid {
  width: number;
  height: number;
  cells: SerializedCell[];
}

export interface SerializedCell {
  type: CellType;
  x: number;
  y: number;
  hp?: number;
  occupantId?: string;
}

export interface Vec2 {
  x: number;
  y: number;
}
